import { fill } from "lodash";

document.addEventListener('DOMContentLoaded', function () {
    const jsFilterGroup = document.querySelectorAll('.jsFilterGroup');
    const body = document.querySelector('body');


    for (let index = 0; index < jsFilterGroup.length; index++) {
        let item = jsFilterGroup[index];
        let trigger = item.querySelector('.jsFilterGroupTrigger');
        let body = item.querySelector('.jsFilterGroupBody');
        let content = item.querySelector('.jsFilterGroupContent');


        trigger.addEventListener('click', () => {
            item.classList.toggle('is-active');
            checkClass()
        })

        if (window.innerWidth > 991){
            checkClass()
        } else{
            if(item.classList.contains('is-active')){
                item.classList.remove('is-active')
            }
        }
        
        function checkClass(){
            if(item.classList.contains('is-active')){
                body.style.maxHeight = content.offsetHeight + 'px';
            } else {
                body.style.maxHeight = '';
            }
        }
    }




    if(document.querySelector('.jsFilter')){
        const jsFilter = document.querySelector('.jsFilter');
        const jsFilterTrigger = jsFilter.querySelector('.jsFilterTrigger');
        const jsFilterContent = jsFilter.querySelector('.jsFilterContent');
        const jsFilterClose = jsFilter.querySelector('.jsFilterClose');
        
        const jsFilterCount = jsFilter.querySelector('.jsFilterCount');

        const jsCheckbox = jsFilter.querySelectorAll('.jsCheckbox');
        const jsRadio = jsFilter.querySelectorAll('.jsRadio');
        const jsInput = jsFilter.querySelectorAll('.jsInput');
        let allInputs = [jsCheckbox, jsRadio, jsInput];

        let checks = 0;
        checks = inputsCheck();

        inputEvent(allInputs);

        function inputEvent(inputs){
            for (let index = 0; index < inputs.length; index++){
                let type = inputs[index];
                
                for (let index = 0; index < type.length; index++){
                    let item = type[index];
        
                    item.addEventListener('change', function(){
                        inputsCheck()
                    })
                    item.addEventListener('input', function(){
                        inputsCheck()
                    })
                }
            }
           
        }

        function inputsCheck(){
            let typeCheckbox = jsFilter.querySelectorAll('.jsCheckbox:checked').length;
            let typeRadio = jsFilter.querySelectorAll('.jsRadio:checked').length;
            let typeText = jsInputFilled();
            let count = typeCheckbox + typeRadio + typeText;
            jsFilterCount.innerHTML = count;
        
            return count;           
            
            function jsInputFilled(){
                let filled = 0;

                for ( let i = 0; i < jsInput.length; i++ ) {
                    if (jsInput[i].value != '') {
                        filled++;
                    }
                }
                
                return filled
            }
        }


        // Filter close/open
        document.addEventListener('click', e => {
            const target = e.target 
            if (jsFilter.classList.contains('is-active')) {
                if (!target.closest('.jsFilter')) {
                    filterClose();
                }
            }
        })

        jsFilterTrigger.addEventListener('click', () => {
            jsFilter.classList.add('is-active');
            jsFilterContent.classList.add('is-active');
            body.classList.add('_backdrop-filter');
        })

        jsFilterClose.addEventListener('click', () => {
            filterClose()
        })

        function filterClose(){
            jsFilter.classList.remove('is-active')
            jsFilterContent.classList.remove('is-active')
            body.classList.remove('_backdrop-filter');
        }
    }
})